import React from 'react';

import {
  KnowledgeBaseComposerDropdownInsertTrackingData,
  KnowledgeBaseInsertHandler,
} from '../../../../../../libs/knowledge-base/shared/components/composerIntegration/knowledgeBaseComposerDropdown';
import {NewPanelId} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {useInteractiveListOnCancel} from '../../../../../../libs/shared/ui/src/components/dropdowns/quickInsert/quickInsertCommon';
import {BoundsRectProvider} from '../../../../../../libs/shared/ui/src/components/reposition/repositionHelpers';
import {KnowledgeBaseComposerDropdownContainer} from '../../../../inboxes/composer/knowledgeBase/knowledgeBaseComposerDropdownContainer';

/*
 * Props.
 */

interface KnowledgeBaseQuickInsertDropdownProps {
  panelId: NewPanelId;
  anchor: BoundsRectProvider;
  onBack: () => void;
  onCancel: () => void;
  onKnowledgeBaseInsertContent: KnowledgeBaseInsertHandler;
  trackOnInsert: (data: KnowledgeBaseComposerDropdownInsertTrackingData) => void;
}

/*
 * Component.
 */

export const KnowledgeBaseQuickInsertDropdown = (props: KnowledgeBaseQuickInsertDropdownProps) => {
  const [onRequestClose, onKnowledgeBaseInsertContent] = useInteractiveListOnCancel(
    props.onCancel,
    props.onKnowledgeBaseInsertContent,
  );

  return (
    <KnowledgeBaseComposerDropdownContainer
      isQuickInsert
      panelId={props.panelId}
      anchor={props.anchor}
      onBackButtonClick={props.onBack}
      onKnowledgeBaseInsertContent={onKnowledgeBaseInsertContent}
      onRequestClose={onRequestClose}
      trackOnInsert={props.trackOnInsert}
    />
  );
};
